import Animated, { FadeIn } from 'react-native-reanimated';

import { Stack } from '@/components/layout';
import { FLOATING_TAB_BAR_CLEARANCE_TOKEN } from '@/components/ui/tabbar';
import { EventDetailContent } from '@/features/guardian/components/event-detail/event-detail-content';
import type { FamilyEvent } from '@/features/guardian/family-events';
import { useEventDetailActions } from '@/features/guardian/hooks/use-event-detail-actions';
import { createStyles, useScaling } from '@/hooks';

type EventDetailTabletPanelProps = {
  event: FamilyEvent;
  contentWidth: number;
  onClose: () => void;
};

export function EventDetailTabletPanel({
  event,
  contentWidth,
  onClose,
}: EventDetailTabletPanelProps) {
  const { scale } = useScaling();
  const styles = useStyles();
  const { handleOpenMap, handleShare, handleReschedule, handleViewBooking } =
    useEventDetailActions();

  return (
    <Stack flex={1} paddingBottom={scale(FLOATING_TAB_BAR_CLEARANCE_TOKEN)}>
      <Animated.View
        entering={FadeIn.duration(160)}
        style={[styles.content, { width: contentWidth }]}>
        <EventDetailContent
          event={event}
          surface="panel"
          onClose={onClose}
          onOpenMap={handleOpenMap}
          onShare={handleShare}
          onReschedule={handleReschedule}
          onViewBooking={handleViewBooking}
        />
      </Animated.View>
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  content: {
    flex: 1,
  },
}));
